export function marcaIntegracao(servico) {
	if (servico?.["s.tipo"] === "99F") {
		return { nome: "99Food", fundo: "#FFD100", texto: "#1A1A1A" }
	}

	return { nome: "iFood", fundo: "#ea1d2c", texto: "white" }
}
